export default __webpack_public_path__ + "static/media/success.52232fe3.gif";